import styles from './VerdictBlock.module.css'
import SoundGuysReview from './SoundGuysReview'
import type { SoundGuysReviewModel } from 'lib/dealhunt/review'

interface VerdictBlockProps {
  review: SoundGuysReviewModel
}

/**
 * The SoundGuys review block. It briefly carried an owner column beside the review
 * ("The verdicts", design 2a, 2026-09-22); with the owner figures in the rail card and the
 * notes under the gallery, that column was one owner block too many (Guillaume, same day),
 * so the block is the review alone again — rating card on the left, verdict, points and the
 * one link to the full review on the right. Nothing here is compared with what owners report.
 */
const VerdictBlock: React.VFC<VerdictBlockProps> = ({ review }) => (
  <section className={styles.block} aria-labelledby="verdicts-heading">
    <h2 id="verdicts-heading" className={styles.heading}>
      {'SoundGuys review'}
    </h2>
    <SoundGuysReview review={review} />
  </section>
)

export default VerdictBlock
